// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vectorFileTitle img {
  margin-right: 6px;
  vertical-align: text-top;
}

.centerflex {
  display: grid;
  justify-content: center;
  align-items: center;
}

.centerflex div {
  text-align: center;
}

.show-data-table {
  position: relative;
}

.next-btn {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1000;
}

.mt-15 {
  margin-top: 15px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background: #003561;
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

mat-icon {
  cursor: pointer;
}

.note {
  background-color: pink;
}

.activemode {
  background-color: #fff;
}

.save-publish-btn {
  height: 35px;
  width: max-content;
}

.active-module-btn {
  color: whitesmoke;
  background-color: rebeccapurple;
}

.module-btn {
  margin: 5px;
  border-radius: 33px;
  border: 1px solid gray;
}

.width-100 {
  width: 100%;
}

.addmat {
  position: relative;
  top: -1px;
  left: -5px;
}

.ml-3 {
  margin-left: 8px;
}

.mid-upload-button .mat-icon {
  font-size: 23px !important;
}


.ft-sm {
  font-size: 11px;
}

th {
  font-family: 'Inter Regular';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  color: #003561;
}

td {
  font-family: 'Inter Regular';
  font-style: normal;
  font-weight: 400;
  min-width: 100px;
  font-size: 12px;
  line-height: 16px;
  color: #003561;
}

.check-icon {
  font-size: 15px;
  height: 15px;
  width: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/assign-user/assign-user-home/assign-user-home.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb","sourcesContent":[".vectorFileTitle img {\n  margin-right: 6px;\n  vertical-align: text-top;\n}\n\n.centerflex {\n  display: grid;\n  justify-content: center;\n  align-items: center;\n}\n\n.centerflex div {\n  text-align: center;\n}\n\n.show-data-table {\n  position: relative;\n}\n\n.next-btn {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n}\n\n.mt-15 {\n  margin-top: 15px;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #003561;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\nmat-icon {\n  cursor: pointer;\n}\n\n.note {\n  background-color: pink;\n}\n\n.activemode {\n  background-color: #fff;\n}\n\n.save-publish-btn {\n  height: 35px;\n  width: max-content;\n}\n\n.active-module-btn {\n  color: whitesmoke;\n  background-color: rebeccapurple;\n}\n\n.module-btn {\n  margin: 5px;\n  border-radius: 33px;\n  border: 1px solid gray;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n.addmat {\n  position: relative;\n  top: -1px;\n  left: -5px;\n}\n\n.ml-3 {\n  margin-left: 8px;\n}\n\n.mid-upload-button .mat-icon {\n  font-size: 23px !important;\n}\n\n\n.ft-sm {\n  font-size: 11px;\n}\n\nth {\n  font-family: 'Inter Regular';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 28px;\n  color: #003561;\n}\n\ntd {\n  font-family: 'Inter Regular';\n  font-style: normal;\n  font-weight: 400;\n  min-width: 100px;\n  font-size: 12px;\n  line-height: 16px;\n  color: #003561;\n}\n\n.check-icon {\n  font-size: 15px;\n  height: 15px;\n  width: 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
